export interface FeedCommentPreview {
  id: string;
  post_id: string | null;
  content: string;
  created_at: string;
  user_id: string | null;
  parent_id?: string | null;
  profiles?: {
    display_name?: string | null;
    avatar_url?: string | null;
  } | null;
}

export const buildLatestFeedCommentMap = (comments: FeedCommentPreview[]) => {
  const latestByPostId: Record<string, FeedCommentPreview> = {};

  for (const comment of comments) {
    if (!comment.post_id) continue;

    const current = latestByPostId[comment.post_id];
    if (!current || new Date(comment.created_at).getTime() > new Date(current.created_at).getTime()) {
      latestByPostId[comment.post_id] = comment;
    }
  }

  return latestByPostId;
};

export const formatFeedReplyCountLabel = (replyCount: number) => {
  if (replyCount <= 0) return 'Reply';
  return `${replyCount} repl${replyCount === 1 ? 'y' : 'ies'}`;
};

export const formatFeedReplySummary = (replyCount: number, latestComment?: FeedCommentPreview | null) => {
  if (replyCount <= 0) return null;

  const author = latestComment?.profiles?.display_name?.trim();
  if (!author) {
    return formatFeedReplyCountLabel(replyCount);
  }

  if (replyCount === 1) {
    return `1 reply from ${author}`;
  }

  return `${replyCount} replies, latest from ${author}`;
};

export const getFeedReplyPreviewText = (content: string, maxLength = 110) => {
  const collapsed = content.replace(/\s+/g, ' ').trim();

  if (collapsed.length <= maxLength) {
    return collapsed;
  }

  return `${collapsed.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
};
